import { isLastSpecialGamesSpin } from '@Core/SpecialGames/SpecialGamesHelper';
import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { TStateResolver } from '@Managers/StateMachine/StateMachine.types';
import { EGameStates } from './GameStates';

export const completeGameStartResolver: TStateResolver<EGameStates> = () => {
    const isGameRestored = gameInstance.gameStore.get(EGameStoreKeys.IsGameRestored);
    if (isGameRestored) return EGameStates.POST_WIN_FEATURES_STATE;

    return EGameStates.IDLE_STATE;
};

export const completeIdleStateResolver: TStateResolver<EGameStates> = () => {
    const { active: debugWinPresentationModeActive } = gameInstance.gameStore.get(EGameStoreKeys.DebugWinPresentationModeState);
    if (debugWinPresentationModeActive) return EGameStates.PRE_WIN_STATE;
    const { gambleRequested } = gameInstance.gameStore.get(EGameStoreKeys.GambleState);
    if (gambleRequested) return EGameStates.PRE_GAMBLE_STATE;
    return EGameStates.PRE_SPIN_STATE;
};

export const completeSpinStateResolver: TStateResolver<EGameStates> = () => {
    const { specialGames, win } = gameInstance.gameStore.get(EGameStoreKeys.SpinOutcome);
    const isFirstSpecialGameSpin = specialGames?.currentSpin === 0;

    return win > 0
        ? EGameStates.PRE_WIN_STATE
        : isFirstSpecialGameSpin || isLastSpecialGamesSpin(gameInstance.gameStore)
          ? EGameStates.POST_WIN_FEATURES_STATE
          : EGameStates.IDLE_STATE;
};

export const postWinStepStateResolver: TStateResolver<EGameStates> = () => {
    const { isLastWinPresentationStep } = gameInstance.gameStore.get(EGameStoreKeys.BaseWinPresentationState);
    if (isLastWinPresentationStep) return undefined;
    return EGameStates.PRE_WIN_STEP_STATE;
};

export const completeWinStateResolver: TStateResolver<EGameStates> = () => {
    const { nextWinPresentationRequested } = gameInstance.gameStore.get(EGameStoreKeys.DebugWinPresentationModeState);
    if (nextWinPresentationRequested) return EGameStates.PRE_WIN_STATE;
    const { gambleRequested } = gameInstance.gameStore.get(EGameStoreKeys.GambleState);
    return gambleRequested ? EGameStates.PRE_GAMBLE_STATE : EGameStates.IDLE_STATE;
};

export const resultGambleStateResolver: TStateResolver<EGameStates> = () => {
    const IsTakeInitiated = gameInstance.gameStore.get(EGameStoreKeys.IsTakeInitiated);
    const amount = gameInstance.gameStore.get(EGameStoreKeys.GambleResponse).gamble?.amount;
    const { tries } = gameInstance.gameStore.get(EGameStoreKeys.GambleState);
    const gambleBackendConfiguration = gameInstance.gameStore.get(EGameStoreKeys.AuthenticateGameConfig).gamble;
    const isFinished = amount === 0 || tries >= gambleBackendConfiguration.maxTries;

    return IsTakeInitiated || isFinished ? EGameStates.POST_GAMBLE_STATE : EGameStates.GAMBLE_STATE;
};

export const completeGambleStateResolver: TStateResolver<EGameStates> = () => {
    return EGameStates.IDLE_STATE;
};
